
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/[category]",
      function () {
        return require("private-next-pages/[slug]/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/[category]"])
      });
    }
  